export default "__VITE_ASSET__BpTCYQAg__"